<template>
	<div
		class="component"
		:class="{
			small: isSmall,
		}"
	>
		<div class="component-modal">
			<div class="d-flex justify-content-between">
				<h3 v-if="!isSmall">{{ 'demo.tutorial.title' | translate }}</h3>
				<h3 v-else></h3>
				<div class="d-flex align-items-center">
					<button class="btn" @click="isSmall = !isSmall">
						<i class="fa fa-compress" aria-hidden="true"></i>
					</button>
					<button class="btn" @click="$emit('close')">
						<i class="fa fa-times" aria-hidden="true"></i>
					</button>
				</div>
			</div>
			<p v-if="!isSmall">{{ 'demo.tutorial.text' | translate }}</p>

			<div class="tutorial">
				<iframe
					width="100%"
					height="100%"
					:src="videoUrl"
					frameborder="0"
					allow="autoplay; encrypted-media"
					allowfullscreen
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'demo-tutorial',
	data: () => ({
		isSmall: false,
	}),
	computed: {
		screenWidth: () => window.innerWidth,
		videoUrl() {
			const i18nLang = this.$store.state.i18n.locale
			if (i18nLang === 'ua') {
				return 'https://www.youtube.com/embed/QF55XVpXuDw'
			} else if (i18nLang === 'pl') {
				return 'https://www.youtube.com/embed/hKjS_PlEG8U'
			} else {
				return 'https://www.youtube.com/embed/MheB2utDoPw'
			}
		},
	},
}
</script>

<style scoped lang="scss">
.component {
	position: fixed;
	bottom: 0;
	left: 0;
	background: rgba(#000, 0.6);
	width: 100%;
	height: 100%;
	transition: width 0.5s, height 0.5s;
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	flex-direction: column;
	padding: 2%;

	&.small {
		padding: 0;
		width: 260px;
		height: 220px;
		bottom: 16px;
		left: 16px;
		background: none;
	}

	p {
		white-space: pre-wrap;
	}
}

.component-modal {
	padding: 16px;
	border-radius: 6px;
	background: #fff;
	color: #333;
	flex-grow: 1;
	overflow: auto;
	width: 100%;
	display: flex;
	flex-direction: column;

	.tutorial {
		min-height: 120px;
		display: flex;
		position: relative;
		flex-grow: 1;
	}

	iframe {
		display: block;
		position: absolute;
		top: 0;
		left: 0;

		height: 0;
		max-height: 100%;
		max-width: 100%;
		min-height: 100%;
		min-width: 100%;
		width: 0;
	}
}
</style>
